import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h2>
              In-App Features for <span>Custom E-commerce Application </span>
              Development
            </h2>
            <p>
              Achieve unparalleled user engagement with our custom E-commerce
              apps, designed to seamlessly integrate cutting-edge in-app
              features.
            </p>
            <p>
              From intuitive navigation to secure authentication, our tailored
              solutions prioritize a natural and immersive shopping experience,
              setting your E-commerce platform apart.
            </p>
            <p>
              TekRevol's E-commerce application development is meticulously
              designed to ensure a top-tier user experience. We present an
              extensive list of features crafted to elevate your E-commerce app,
              guaranteeing its success across various app stores.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get a Free Quote Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-lg-3 offset-md-3 my-auto"
          >
            <div className="industry_scroll">
              <h3>Available on iTunes & Google Play Store</h3>
              <h3>Shop For Multiple Products</h3>
              <h3>Admob</h3>
              <h3>Real Estate</h3>
              <h3>Sign up & Sign in</h3>
              <h3>User Profile</h3>
              <h3>My Wishlist Option</h3>
              <h3>Product/Category Segregation</h3>
              <h3>Product Details</h3>
              <h3>Sliders/Carousel</h3>
              <h3>Email/Push Notifications</h3>
              <h3>Codes And Coupons</h3>
              <h3>Cart</h3>
              <h3>Multilingual</h3>
              <h3>Rate/Review Options</h3>
              <h3>Multiple Payment Options Support</h3>
              <h3>Social Login</h3>
              <h3>User Shopping History</h3>
              <h3>Product Review/ Rating</h3>
              <h3>Streamlined Checkout</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industryusa;
